// extracted by mini-css-extract-plugin
export var progressBar = "_kz-0";
export var progressBarInner = "_kz-1";